<rect
    x="0.666667"
    y="0.666667"
    width="48.6667"
    height="48.6667"
    rx="24.3333"
    stroke="#E6E8EC"
    stroke-width="1.33333"
/>
<path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M25.0002 34.3333C30.1548 34.3333 34.3335 30.1546 34.3335 24.9999C34.3335 19.8453 30.1548 15.6666 25.0002 15.6666C19.8455 15.6666 15.6668 19.8453 15.6668 24.9999C15.6668 30.1546 19.8455 34.3333 25.0002 34.3333ZM25.0002 36.6666C31.4434 36.6666 36.6668 31.4432 36.6668 24.9999C36.6668 18.5566 31.4434 13.3333 25.0002 13.3333C18.5568 13.3333 13.3335 18.5566 13.3335 24.9999C13.3335 31.4432 18.5568 36.6666 25.0002 36.6666Z"
    fill="#777E91"
/>
<path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M21.3574 22.4962C20.68 23.738 20.6582 25.3747 21.3767 26.8116C21.6648 27.3879 21.4312 28.0886 20.8549 28.3768C20.2786 28.665 19.5778 28.4314 19.2897 27.8551C18.2581 25.7919 18.2363 23.3453 19.309 21.3788C20.4082 19.3635 22.5743 18 25.5832 18C27.8663 18 29.5992 19.0289 30.6806 20.5312C31.7369 21.9988 32.1444 23.8728 31.9459 25.6057C31.7474 27.3399 30.9221 29.0655 29.3514 30.1037C28.0109 30.9897 26.2846 31.2731 24.271 30.8161L23.2073 34.6455C23.0348 35.2664 22.3917 35.6299 21.7709 35.4574C21.1501 35.285 20.7866 34.6419 20.9591 34.0211L22.3349 29.0679C22.337 29.0605 22.339 29.0529 22.3412 29.0454L23.8758 23.5211C24.0482 22.9002 24.6913 22.5368 25.3122 22.7093C25.9329 22.8817 26.2964 23.5248 26.1239 24.1455L24.8962 28.5653C26.3557 28.8746 27.3794 28.6101 28.0647 28.1571C28.9315 27.5842 29.4882 26.5584 29.6278 25.3403C29.7673 24.1212 29.4688 22.8419 28.7867 21.8943C28.1297 20.9815 27.0918 20.3333 25.5832 20.3333C23.3421 20.3333 22.0081 21.3031 21.3574 22.4962Z"
    fill="#777E91"
/>
